var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Button',{staticStyle:{"padding":"8px"},attrs:{"loading":_vm.isLoading,"shape":_vm.shape,"disabled":_vm.disabled},on:{"click":_vm.multiClearCache}},[_c('img',{staticStyle:{"width":"16px"},attrs:{"src":"/static/img/broom.svg"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1b455224","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ClearCacheBtn.vue
// module id = null
// module chunks = 